import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Globe, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const NoCoordinatesView = () => {
    const { t } = useTranslation();

    return (
        <Card className="border border-border shadow-sm">
            <CardHeader className="pb-3">
                <CardTitle className="text-lg font-medium flex items-center gap-2">
                    <MapPin className="h-5 w-5 text-muted-foreground" />
                    {t('properties.location.map')}
                </CardTitle>
            </CardHeader>
            <CardContent className="p-6 flex flex-col items-center justify-center gap-4 text-center text-muted-foreground">
                <Globe className="h-16 w-16 opacity-20" />
                <p>{t('properties.location.noCoordinates')}</p>
            </CardContent>
        </Card>
    );
}; 